var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var RENDER = '__NEXT_REDUX_WRAPPER_FIRST_RENDER__';
var REQPROP = '__NEXT_REDUX_WRAPPER_STORE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserialized = function (actions, _a) {
    var _b = _a === void 0 ? {} : _a, deserialize = _b.deserialize;
    return (deserialize ? deserialize(actions) : actions);
};
var getSerialized = function (actions, _a) {
    var _b = _a === void 0 ? {} : _a, serialize = _b.serialize;
    return (serialize ? serialize(actions) : actions);
};
export var Source;
(function (Source) {
    Source["GIAP"] = "GIAP";
    Source["GIPP"] = "GIPP";
    Source["GSP"] = "GSP";
    Source["GSSP"] = "GSSP";
})(Source || (Source = {}));
var sharedClientStore;
var undefinedReplacer = function (key, value) { return (typeof value === 'undefined' ? null : value); };
var createMiddleware = function (config) {
    var log = [];
    var reduxWrapperMiddleware = function (api) { return function (next) { return function (action) {
        if (!getIsServer()) {
            return next(action);
        }
        action = JSON.parse(JSON.stringify(action, undefinedReplacer)); //FIXME Let serialize take care of it?
        log.push(action);
        return next(action);
    }; }; };
    return { log: log, reduxWrapperMiddleware: reduxWrapperMiddleware };
};
var initStore = function (_a) {
    var _b, _c, _d;
    var makeStore = _a.makeStore, _e = _a.context, context = _e === void 0 ? {} : _e, config = _a.config;
    var createStore = function () {
        var _a = createMiddleware(config), log = _a.log, reduxWrapperMiddleware = _a.reduxWrapperMiddleware;
        var store = makeStore({ context: context, reduxWrapperMiddleware: reduxWrapperMiddleware });
        return { store: store, log: log };
    };
    if (getIsServer()) {
        var req = ((_b = context) === null || _b === void 0 ? void 0 : _b.req) || ((_d = (_c = context) === null || _c === void 0 ? void 0 : _c.ctx) === null || _d === void 0 ? void 0 : _d.req);
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req[REQPROP]) {
                if (config.debug) {
                    console.log('1. Store created within request');
                }
                req[REQPROP] = createStore(); // GIP/GSSP
            }
            else if (config.debug) {
                console.log('1. Store reused from request');
            }
            return req[REQPROP];
        }
        if (config.debug) {
            console.log('1. Store created without request');
        }
        return createStore(); // GSP or server rendering
    }
    // Memoize the store if we're on the client
    if (!sharedClientStore) {
        if (config.debug) {
            console.log('1. Store created on client');
        }
        sharedClientStore = createStore();
    }
    return sharedClientStore;
};
/**
 * Returns an array of tuples with state and source. An array is needed to guarantee the order.
 * Returns an empty array if it does not recognize state
 *
 * If GSP has run, then state will _not_ contain the data from GIAP (if it exists), because GSP is run at build
 * time, and GIAP runs at request time.
 *
 * So we have to hydrate the GSP data first, and then do another hydrate on the GIAP state.
 *
 * If GSSP has run, then state _will_ contain the data from GIAP (if there is a GIAP) and the GSSP data combined
 * (see https://github.com/kirill-konshin/next-redux-wrapper/pull/499#discussion_r1014500941), thus one hydrate.
 * !!! Not applied anymore since we flush log after dispatches.
 *
 * If there is no GSP or GSSP for this page, but there is a GIPP (not _app), there will be one hydrate.
 *
 * If there is no GSP or GSSP and no GIP on page level for this page, but there is a GIAP on _app level there
 * will be also one hydrate.
 *
 * GIPP (partial) -> GIAP (full)
 * GIAP (partial) -> GSSP (full)
 * GIAP (partial) -> GSP (partial)
 */
var getStates = function (_a) {
    var reduxWrapperActionsGSSP = _a.reduxWrapperActionsGSSP, reduxWrapperActionsGSP = _a.reduxWrapperActionsGSP, reduxWrapperActionsGIAP = _a.reduxWrapperActionsGIAP, reduxWrapperActionsGIPP = _a.reduxWrapperActionsGIPP;
    var map = new Map();
    if (reduxWrapperActionsGIAP) {
        if (reduxWrapperActionsGIPP) {
            // send both as they both are partial, order is important as GIPP happens before GIAP
            map.set(Source.GIPP, reduxWrapperActionsGIPP);
            map.set(Source.GIAP, reduxWrapperActionsGIAP);
        }
        else if (reduxWrapperActionsGSSP) {
            // send both as they both are partial, order is important as GIAP happens before GSSP
            map.set(Source.GIAP, reduxWrapperActionsGIAP);
            map.set(Source.GSSP, reduxWrapperActionsGSSP);
        }
        else if (reduxWrapperActionsGSP) {
            // send both as they both are partial, order is important as GSP happens way before GIAP
            map.set(Source.GSP, reduxWrapperActionsGSP);
            map.set(Source.GIAP, reduxWrapperActionsGIAP);
        }
        else {
            map.set(Source.GIAP, reduxWrapperActionsGIAP); // simply return GIAP
        }
    }
    else if (reduxWrapperActionsGSP) {
        map.set(Source.GSP, reduxWrapperActionsGSP);
    }
    else if (reduxWrapperActionsGSSP) {
        map.set(Source.GSSP, reduxWrapperActionsGSSP);
    }
    else if (reduxWrapperActionsGIPP) {
        map.set(Source.GIPP, reduxWrapperActionsGIPP);
    }
    return map;
};
var dispatchStates = function (dispatch, states, config) {
    return getStates(states).forEach(function (actions, source) {
        return getDeserialized(actions, config).forEach(function (action) {
            return dispatch(__assign(__assign({}, action), { meta: __assign(__assign({}, action.meta), { source: source }) }));
        });
    });
};
export var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(this, void 0, void 0, function () {
            var _b, store, log, nextCallback, initialProps, _c, reduxWrapperActions;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = initStore({ context: context, makeStore: makeStore, config: config }), store = _b.store, log = _b.log;
                        nextCallback = callback && callback(store);
                        _c = nextCallback;
                        if (!_c) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _c = (_d.sent());
                        _d.label = 2;
                    case 2:
                        initialProps = ((_c) || {});
                        if (config.debug) {
                            console.log("2. initial state after dispatches", store.getState(), 'actions', log);
                        }
                        reduxWrapperActions = getSerialized(__spreadArray([], log, true), config);
                        log.splice(0, log.length); // flush all logs
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                reduxWrapperActions: reduxWrapperActions,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) {
        return function (context) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, reduxWrapperActions, initialProps;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!context.query || !context.pathname || !context.AppTree) {
                            throw new Error("Looks like you've used getInitialPageProps for different kind of lifecycle method");
                        }
                        return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                    case 1:
                        _a = _b.sent(), reduxWrapperActions = _a.reduxWrapperActions, initialProps = _a.initialProps;
                        return [2 /*return*/, __assign(__assign({}, initialProps), { reduxWrapperActionsGIPP: reduxWrapperActions })];
                }
            });
        }); };
    };
    var getInitialAppProps = function (callback) {
        return function (context) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, reduxWrapperActions, initialProps;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!context.router || !context.Component || !context.AppTree || !context.ctx) {
                            throw new Error("Looks like you've used getInitialAppProps for different kind of lifecycle method");
                        }
                        return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                    case 1:
                        _a = _b.sent(), reduxWrapperActions = _a.reduxWrapperActions, initialProps = _a.initialProps;
                        return [2 /*return*/, __assign(__assign({}, initialProps), { pageProps: __assign(__assign({}, initialProps.pageProps), { reduxWrapperActionsGIAP: reduxWrapperActions }) })];
                }
            });
        }); };
    };
    var getStaticProps = function (callback) {
        return function (context) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, reduxWrapperActions, initialProps;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                    case 1:
                        _a = _b.sent(), reduxWrapperActions = _a.reduxWrapperActions, initialProps = _a.initialProps;
                        return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { reduxWrapperActionsGSP: reduxWrapperActions }) })];
                }
            });
        }); };
    };
    var getServerSideProps = function (callback) {
        return function (context) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, reduxWrapperActions, initialProps;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!context.req || !context.res || !context.resolvedUrl || !context.query) {
                            throw new Error("Looks like you've used getServerSideProps for different kind of lifecycle method");
                        }
                        return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                    case 1:
                        _a = _b.sent(), reduxWrapperActions = _a.reduxWrapperActions, initialProps = _a.initialProps;
                        return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { reduxWrapperActionsGSSP: reduxWrapperActions }) })];
                }
            });
        }); };
    };
    var useStore = function () { return useMemo(function () { return initStore({ makeStore: makeStore, config: config }).store; }, []); };
    var useHydration = function (_a) {
        var reduxWrapperActionsGSSP = _a.reduxWrapperActionsGSSP, reduxWrapperActionsGSP = _a.reduxWrapperActionsGSP, reduxWrapperActionsGIAP = _a.reduxWrapperActionsGIAP, reduxWrapperActionsGIPP = _a.reduxWrapperActionsGIPP;
        var dispatch = useDispatch();
        var _b = useState(true), hydrating = _b[0], setHydrating = _b[1];
        var hydrate = useCallback(function () {
            return dispatchStates(dispatch, {
                reduxWrapperActionsGSSP: reduxWrapperActionsGSSP,
                reduxWrapperActionsGSP: reduxWrapperActionsGSP,
                reduxWrapperActionsGIAP: reduxWrapperActionsGIAP,
                reduxWrapperActionsGIPP: reduxWrapperActionsGIPP,
            }, config);
        }, [dispatch, reduxWrapperActionsGSSP, reduxWrapperActionsGSP, reduxWrapperActionsGIAP, reduxWrapperActionsGIPP]);
        // This guard is solely to suppress Next.js warning about useless layout effect
        // Coverage is not gathered, all checks are via demo apps
        /* c8 ignore start */
        if (!getIsServer()) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useLayoutEffect(function () {
                if (!window[RENDER]) {
                    window[RENDER] = true;
                    return;
                }
                // if there are only GIAP or GIPP these actions were already dispatched on client side
                if (!reduxWrapperActionsGSP && !reduxWrapperActionsGSSP) {
                    if (config.debug) {
                        console.log('4. useHydration effect skipped');
                    }
                    return;
                }
                setHydrating(true);
                if (config.debug) {
                    console.log('3. useHydration effect');
                }
                hydrate();
                setHydrating(false);
                if (config.debug) {
                    console.log('4. useHydration done');
                }
            }, [dispatch, hydrate, reduxWrapperActionsGSP, reduxWrapperActionsGSSP]);
            if (window[RENDER]) {
                return { hydrating: hydrating };
            }
        }
        /*c8 ignore end */
        /**
         * When we navigate client side, we may always synchronously hydrate the state before the new page components
         * are mounted. This means we hydrate while the previous page components are still mounted.
         *
         * This will cause ugly react message, that you're trying to update state of a component while rendering another.
         * Warnings only appear in development mode.
         *
         * You might think that might cause issues because the selectors on the previous page (still mounted) will suddenly
         * contain other data, and maybe even nested properties, causing null reference exceptions.
         *
         * But that's not the case.
         *
         * Hydrating synchronously will not trigger a rerender of the still mounted page component. So if your selectors do
         * have some initial state values causing them to rerun after hydration, and you're accessing deeply nested values
         * inside your components, you still wouldn't get errors, because there's no rerender.
         *
         * Instead, React will render the new page components straight away, which will have selectors with the correct data.
         *
         * So technically, other than an ugly warning, this does not have consequences. Nevertheless, subsequent navigation
         * events (without reload) will be dispatched from useEffect, properly. This means that for split second selectors
         * may render empty data. React may batch state updates though (or not).
         */
        if (config.debug) {
            console.log('3. useHydration sync');
        }
        hydrate();
        if (config.debug) {
            console.log('4. useHydration done');
        }
        return { hydrating: false };
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        useStore: useStore,
        useHydration: useHydration,
    };
};
//# sourceMappingURL=index.js.map